/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import './aiAccessReqDashBoard.scss';

const SummaryElement = ({
  pendingApprovals = 0,
  pendingAccess = 0,
  usageData = [],
  canViewAiAccessRequestDashBoard = false,
}) => {
  // Guard against null/undefined usageData
  const safeUsageData = useMemo(() => (Array.isArray(usageData) ? usageData : []), [usageData]);

  // Dynamically calculate the total count
  const totalEmployees = useMemo(() => {
    return safeUsageData.reduce((acc, curr) => acc + (Number(curr.employees) || 0), 0);
  }, [safeUsageData]);

  return (
    <>
      <div className="ai-usage-dashboard-container">
        {/* 1. Stat Cards Row */}
        <div className="summary-cards-wrapper">
          <div className="stat-card">
            <span className="stat-title">Pending Approvals</span>
            <span className="stat-value">{pendingApprovals}</span>
          </div>
          <div className="stat-card">
            <span className="stat-title">Pending Access</span>
            <span className="stat-value">{pendingAccess}</span>
          </div>
        </div>

        {/* 2. Usage Table Section */}
        <div className="usage-table-section">
          <h3 className="section-heading">AI Tool Usage Across Employees</h3>

          <div className="table-wrapper">
            <table className="ai-usage-table">
              <thead>
                <tr>
                  <th className="text-left">No. of Tools</th>
                  <th className="text-right">No. of Employees</th>
                </tr>
              </thead>
              <tbody>
                {safeUsageData.length > 0 ? (
                  safeUsageData.map((row) => (
                    <tr key={row.tools}>
                      <td className="text-left">{row.tools}</td>
                      <td className="text-right">{row.employees}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                    No data available
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td className="text-left font-bold">Total</td>
                  <td className="text-right font-bold">{totalEmployees}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      {canViewAiAccessRequestDashBoard && (
        <div className="ai-access-req-dashboard-footer">
          <span className="ai-access-req-dashboard-footer-text">AI Tool Usage Across Projects</span>
        </div>
      )}
    </>
  );
};

export default SummaryElement;
